import React, { useReducer, useEffect } from "react";
import {
  Table,
  Row,
  Col,
  Button,
  Alert,
  Card,
  Accordion,
} from "react-bootstrap";
import ModuleDisplayEmail from "../modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../modules/fieldsDisplay/ModuleDisplayPhone";
import axios from "../../../config/axios";
import moduleConfig from "../../modules/testimonial/moduleConfig";
import {
  listingInitialState,
  listingReducer,
} from "../../../reducers/module/listingReducer";
import { Link, useNavigate } from "react-router-dom";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import { getFullName } from "../../../helpers/CommonHelper";
import ModuleDisplayBoolean from "../modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDate from "../modules/fieldsDisplay/ModuleDisplayDate";
import { FaUser } from "react-icons/fa";
import { LuUserCheck, LuUserRoundMinus } from "react-icons/lu";
function TestimonialContent({ setParent, parent }) {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  };
  const loadItems = async () => {
    listingDispatch({ type: "FETCH_REQUEST" });
    setParent(true);

    try {
      // Run all requests in parallel for speed
      const [
        testimonialsRes,
        contactUsRes,
        partyRequestRes,
        schoolNurseryRes,
        jobApplicationsRes,
        productReturnRes,
      ] = await Promise.all([
        axios.get(`testimonials?limit=5`),
        axios.get(`contact-us?limit=5`),
        axios.get(`party-requests?limit=5`),
        axios.get(`school-nursery-requests?limit=5`),
        axios.get(`job-applications?limit=5`),
        axios.get(`product-return-requests?limit=5`),
      ]);

      // Combine all API data in one object
      const combinedData = {
        testimonials: testimonialsRes.data?.items ?? [],
        contactUs: contactUsRes.data?.items ?? [],
        partyRequests: partyRequestRes.data?.items ?? [],
        schoolNurseryRequests: schoolNurseryRes.data?.items ?? [],
        jobApplications: jobApplicationsRes.data?.items ?? [],
        productReturns: productReturnRes.data?.items ?? [],
      };

      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: combinedData,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    } finally {
      setParent(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);

  return (
    <>
      {listingState.hasFetchingError && (
        <Alert variant="warning mb-0 mt-1">
          OOPS!!! Something went wrong, please try again later.
        </Alert>
      )}

      <Row className="mt-2 mb-3">
        <Col xl={12}>
          <Accordion defaultActiveKey="1" className="custom-accordion">
            <Accordion.Item
              eventKey="1"
              className="border-0 shadow-sm mb-3 rounded-3 overflow-hidden"
            >
              <Accordion.Header className="bg-custom-6 rounded-top-3">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Recent Testimonials</h6>
                  {listingState.data?.testimonials?.length > 0 && (
                    <button
                      title="View all testimonials"
                      className="btn btn-sm btn-custom-2 me-3"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent accordion toggle on button click
                        handleNavigate("/testimonials");
                      }}
                    >
                      View All
                    </button>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-1 bg-white">
                {!listingState.data?.testimonials?.length ? (
                  <Alert className="alert-custom-1 mb-0 mt-1">No records found.</Alert>
                ) : (
                  <div className="table-responsive">
                    <table className="table  table-sm mt-1 smallTable mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Full Name</th>
                          <th>Message</th>
                          <th>Submission Date</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingState.data.testimonials.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.name || "—"}</td>
                            <td
                              className="text-truncate"
                              style={{ maxWidth: "220px" }}
                            >
                              {item?.message || "—"}
                            </td>
                            <td>
                              {item?.createdAt ? (
                                <ModuleDisplayDate value={item?.createdAt} />
                              ) : (
                                "—"
                              )}
                            </td>
                            <td>
                              <ModuleDisplayBoolean
                                value={item?.status}
                                trueValue="Enabled"
                                falseValue="Disabled"
                              />
                            </td>
                            <td>
                              <Link
                                title="View Item"
                                to={`/testimonials/${item._id}`}
                                className="btn btn-outline-secondary btn-sm"
                              >
                                <i className="fas fa-eye"></i>
                              </Link>
                            </td>{" "}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col xl={12}>
          <Accordion defaultActiveKey="0" className="custom-accordion">
            <Accordion.Item
              eventKey="1"
              className="border-0 shadow-sm mb-3 rounded-3 overflow-hidden"
            >
              <Accordion.Header className="bg-custom-6 rounded-top-3">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Recent Contact Us</h6>
                  {listingState.data?.contactUs?.length > 0 && (
                    <button
                      title="View all Contact Us submissions"
                      className="btn btn-sm btn-custom-2 me-3"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent accordion toggle when clicking button
                        handleNavigate("/contact-us");
                      }}
                    >
                      View All
                    </button>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-1 bg-white">
                {!listingState.data?.contactUs?.length ? (
                  <Alert className="alert-custom-1 mb-0 mt-1">
                    No records found.
                  </Alert>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm mt-1 smallTable mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Full Name</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <th>Message</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingState.data.contactUs.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.name || "—"}</td>
                            <td>
                              <ModuleDisplayEmail value={item?.email} />
                            </td>
                            <td>
                              <ModuleDisplayPhone value={item?.mobile} />
                            </td>
                            <td
                              className="text-truncate"
                              style={{ maxWidth: "220px" }}
                            >
                              {item?.message || "—"}
                            </td>
                            <td>
                              <Link
                                title="View Item"
                                to={`/contact-us/${item._id}`}
                                className="btn btn-outline-secondary btn-sm"
                              >
                                <i className="fas fa-eye"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col xl={12}>
          <Accordion defaultActiveKey="0" className="custom-accordion">
            <Accordion.Item
              eventKey="1"
              className="border-0 shadow-sm mb-3 rounded-3 overflow-hidden"
            >
              <Accordion.Header className="bg-custom-6 rounded-top-3">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Recent Party Requests</h6>
                  {listingState.data?.partyRequests?.length > 0 && (
                    <button
                      title="View all Party Requests"
                      className="btn btn-sm btn-custom-2 me-3"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent accordion toggle on click
                        handleNavigate("/party-requests");
                      }}
                    >
                      View All
                    </button>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-1 bg-white">
                {!listingState.data?.partyRequests?.length ? (
                  <Alert className="alert-custom-1 mb-0 mt-1">
                    No records found.
                  </Alert>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm mt-1 smallTable mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Parent Name</th>
                          <th>Email</th>
                          <th>Occasion</th>
                          <th>No. of Children</th>
                          <th>Event Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingState.data.partyRequests.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.parentName || "—"}</td>
                            <td>
                              <ModuleDisplayEmail value={item?.email} />
                            </td>
                            <td>{item?.occasion || "—"}</td>
                            <td>{item?.numberOfChildren || "—"}</td>
                            <td>
                              <ModuleDisplayDate value={item?.eventDate} />
                            </td>
                            <td>
                              <Link
                                title="View Item"
                                to={`/party-requests/${item._id}`}
                                className="btn btn-outline-secondary btn-sm"
                              >
                                <i className="fas fa-eye"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col xl={12}>
          <Accordion defaultActiveKey="0" className="custom-accordion">
            <Accordion.Item
              eventKey="1"
              className="border-0 shadow-sm mb-3 rounded-3 overflow-hidden"
            >
              <Accordion.Header className="bg-custom-6 rounded-top-3">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Recent School/Nursery Requests</h6>
                  {listingState.data?.schoolNurseryRequests?.length > 0 && (
                    <button
                      title="View all School/Nursery Requests"
                      className="btn btn-sm btn-custom-2 me-3"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent accordion toggle on button click
                        handleNavigate("/school-nursery-requests");
                      }}
                    >
                      View All
                    </button>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-1 bg-white">
                {!listingState.data?.schoolNurseryRequests?.length ? (
                  <Alert className="alert-custom-1 mb-0 mt-1">
                    No records found.
                  </Alert>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm mt-1 smallTable mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>School/Nursery Name</th>
                          <th>Contact Person</th>
                          <th>Contact Person Role</th>
                          <th>Mobile</th>
                          <th>No. of Children</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingState.data.schoolNurseryRequests.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item?.schoolNurseryName || "—"}</td>
                              <td>{item?.contactPersonName || "—"}</td>
                              <td>{item?.contactPersonRole || "—"}</td>
                              <td>
                                <ModuleDisplayPhone value={item?.mobile} />
                              </td>
                              <td>{item?.numberOfChildren || "—"}</td>
                              <td>
                                <Link
                                  title="View Item"
                                  to={`/school-nursery-requests/${item._id}`}
                                  className="btn btn-outline-secondary btn-sm"
                                >
                                  <i className="fas fa-eye"></i>
                                </Link>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col xl={12}>
          <Accordion defaultActiveKey="0" className="custom-accordion">
            <Accordion.Item
              eventKey="1"
              className="border-0 shadow-sm mb-3 rounded-3 overflow-hidden"
            >
              <Accordion.Header className="bg-custom-6 rounded-top-3">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Recent Job Applications</h6>
                  {listingState.data?.jobApplications?.length > 0 && (
                    <button
                      title="View all Job Applications"
                      className="btn btn-sm btn-custom-2 me-3"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent accordion toggle on button click
                        handleNavigate("/job-applications");
                      }}
                    >
                      View All
                    </button>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-1 bg-white">
                {!listingState.data?.jobApplications?.length ? (
                  <Alert className="alert-custom-1 mb-0 mt-1">
                    No records found.
                  </Alert>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm mt-1 smallTable mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Full Name</th>
                          <th>Email</th>
                          <th>Position Applied</th>
                          <th>Notice Period</th>
                          <th>Applied Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingState.data.jobApplications.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{`${item?.firstName || ""} ${
                                item?.lastName || ""
                              }`}</td>
                              <td>
                                <ModuleDisplayEmail value={item?.email} />
                              </td>
                              <td>{item?.job?.title || "—"}</td>
                              <td>{item?.noticePeriod || "—"}</td>
                              <td>
                                <ModuleDisplayDate value={item?.appliedDate} />
                              </td>
                              <td>
                                <Link
                                  title="View Item"
                                  to={`/job-applications/${item._id}`}
                                  className="btn btn-outline-secondary btn-sm"
                                >
                                  <i className="fas fa-eye"></i>
                                </Link>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mb-3">
          <Accordion defaultActiveKey="0" className="custom-accordion">
            <Accordion.Item eventKey="1" className="border-0 shadow-sm">
              <Accordion.Header>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h6 className="mb-0">Recent Product Returns</h6>
                  {listingState.data?.productReturns?.length > 0 && (
                    <button
                      title="Please click to view all returns"
                      className="btn btn-sm btn-custom-2 me-3"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent accordion toggle
                        handleNavigate(`/returns`);
                      }}
                    >
                      View all
                    </button>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-1">
                {!listingState.data?.productReturns?.length && (
                  <Alert className="alert-custom-1 mb-0 mt-1">
                    No records found.
                  </Alert>
                )}

                {listingState.data?.productReturns?.length > 0 && (
                  <div className="table-responsive mt-2">
                    <table className="table  table-sm smallTable mb-0">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "120px" }}>Order ID</th>
                          <th style={{ width: "140px" }}>Full Name</th>
                          <th>Product</th>
                          <th style={{ width: "150px" }}>Requested Date</th>
                          <th
                            className="text-center"
                            style={{ width: "120px" }}
                          >
                            Status
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingState.data.productReturns.map((item, index) => (
                          <tr key={index}>
                            <td>{item.orderId || "-"}</td>
                            <td>{item.customer?.fullName || "-"}</td>
                            <td>{item.product?.title || "-"}</td>
                            <td>
                              <ModuleDisplayDate value={item.createdAt} />
                            </td>
                            <td className="text-center">
                              <span
                                className={`status ${
                                  item.status === "1"
                                    ? "active"
                                    : item.status === "0"
                                    ? "inactive"
                                    : "cancelled"
                                }`}
                              >
                                {item.status === "1"
                                  ? "Approved"
                                  : item.status === "0"
                                  ? "Pending"
                                  : "Rejected"}
                              </span>
                            </td>
                            <td>
                              <Link
                                title="View Item"
                                to={`/returns/${item._id}`}
                                className="btn btn-outline-secondary btn-sm"
                              >
                                <i className="fas fa-eye"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </>
  );
}

export default TestimonialContent;
